import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, IconButton, Paper, Stack, Typography, useTheme, } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import { useRef } from 'react';
export const Uploader = ({ onFileChange }) => {
    const theme = useTheme();
    const fileInputRef = useRef(null);
    const handleBrowseFilesClick = () => {
        if (fileInputRef.current)
            fileInputRef.current.click();
    };
    return (_jsxs(Paper, { variant: "outlined", sx: {
            padding: '8px',
            borderStyle: 'dashed',
            backgroundColor: theme.palette.grey[100],
        }, children: [_jsxs(Stack, { direction: "row", justifyContent: "space-between", alignItems: "center", children: [_jsxs(Stack, { direction: "row", gap: "16px", children: [_jsx(IconButton, { size: "medium", sx: {
                                    height: 'fit-content',
                                    borderRadius: '4px',
                                    backgroundColor: theme.palette.grey[300],
                                }, children: _jsx(FileUploadOutlinedIcon, { fontSize: "medium" }) }), _jsxs(Box, { children: [_jsx(Typography, { fontWeight: 700, fontSize: "12px", letterSpacing: "0.15px", children: "Drag file(s) here or browse your files" }), _jsx(Typography, { fontWeight: 400, fontSize: "12px", letterSpacing: "0.4px", children: "Limit 200 MB per file - MP4, MEPG4" })] })] }), _jsx(Button, { variant: "outlined", color: "success", sx: { height: 'fit-content' }, onClick: handleBrowseFilesClick, children: "Browse Files" })] }), _jsx("input", { type: "file", accept: ".mp4, .mpeg4", multiple: true, ref: fileInputRef, style: { display: 'none' }, onChange: onFileChange })] }));
};
